import Api from "../../../lib/api";
import StringHelper from "../../../lib/string-helper";
import Header from "../../../global/header";
import HeaderTemplates from "./templates";
import SiteNavSearch from "./site-nav-search";
import MobileNavSearch from "./mobile-nav-search";

export default class BlogHeader extends Header {
	constructor(props) {
		super(props);
	}

	/* Desktop methods */
	initDesktop() {
		super.initDesktop();
		this.adjustDesktopLinks();
		this.initSiteNavSearch();
	}

	initSiteNavSearch() {
		const siteNavSearch = new SiteNavSearch();
	}

	adjustDesktopLinks() {
		const cityId = Api.currentCityId;
		const cityInfo = craft.env.cityInfo.find(({ id }) => id === cityId);

		if (!cityInfo) {
			throw new Error('Header: cityInfo of ' + cityId + ' city id is not defined');
		}

		const $currentCityLink = this.$root.querySelector(`.header-bar_left [data-city-id="${cityId}"]`);
		const $headerTelContainer = document.getElementById('headerTelContainer');
		const $headerEmail = this.$root.querySelector('.header-contacts-dropdown_email');
		const $headerEmailText = $headerEmail.querySelector('span');
		const $siteNavLinks = this.$root.querySelectorAll('[data-switch-link="site-nav"]');
		const $siteNavDropdownItemUcan = document.getElementById('siteNavDropdownItemUcan');

		/* Set active class to the header bar current city link */
		if ($currentCityLink) {
			$currentCityLink.classList.add('-active');
		}

		/* Insert current city contacts html content to the header bar contacts dropdown */
		if ($headerTelContainer) {
			const tel1 = cityInfo.tel1;
			const tel2 = cityInfo.tel2;
			const template = HeaderTemplates.headerContactsTelContainer(cityId, tel1, tel2);

			$headerTelContainer.innerHTML = '';
			$headerTelContainer.insertAdjacentHTML('afterbegin', template);

			if (!tel2) {
				$headerTelContainer.classList.add('-single');
			} else {
				$headerTelContainer.classList.remove('-single');
			}
		}

		/* Set header bar contacts dropdown email */
		if ($headerEmail) {
			$headerEmail.href = 'mailto:' + cityInfo.email;
			$headerEmailText.textContent = cityInfo.email;
		}

		/* Set current city urls */
		if ($siteNavLinks.length) {
			$siteNavLinks.forEach(($siteNavLink) => {
				const trimmed = StringHelper.trimUrlOrigin($siteNavLink.href);

				if (trimmed === '/') {
					$siteNavLink.href = cityInfo.url;
				} else {
					$siteNavLink.href = cityInfo.url + trimmed;
				}
			});
		}

		/* Hide ucan page link if ucan courses is not available in current city */
		if ($siteNavDropdownItemUcan && !cityInfo.ucanAvailable) {
			$siteNavDropdownItemUcan.remove();
		}
	}

	/* Mobile methods */
	initMobile() {
		super.initMobile();
		this.initMobileNavSearch();
		this.adjustMobileLinks();
	}

	initMobileNavSearch() {
		const mobileNavSearch = new MobileNavSearch(document.getElementById('mobileNavMenuMain'));
	}

	adjustMobileLinks() {
		const cityId = Api.currentCityId;
		const cityInfo = craft.env.cityInfo.find(({ id }) => id === cityId);

		if (!cityInfo) {
			throw new Error('Header: cityInfo of ' + cityId + ' city id is not defined');
		}

		const $mobileMenu = document.getElementById('mobileNavMenuMain');
		const $currentCityLink = $mobileMenu.querySelector(`.mobile-nav-menu_item.-cities [data-city-id="${cityId}"]`);
		const $mobileNavLinks = $mobileMenu.querySelectorAll('[data-switch-link="mobile-nav"]');
		const $telLink = $mobileMenu.querySelector('.mobile-nav-menu_tel[data-switch-tel="mobile-nav"]')

		/* Set active class to the header bar current city link */
		if ($currentCityLink) {
			$currentCityLink.classList.add('-selected');
		}

		/* Set current city urls */
		if ($mobileNavLinks.length) {
			$mobileNavLinks.forEach(($mobileNavLink) => {
				const trimmed = StringHelper.trimUrlOrigin($mobileNavLink.href);

				if (trimmed === '/') {
					$mobileNavLink.href = cityInfo.url;
				} else {
					$mobileNavLink.href = cityInfo.url + trimmed;
				}
			});
		}

		/* Set current city tel */
		if ($telLink) {
			$telLink.href = 'tel:' + cityInfo.tel1;
			$telLink.textContent = cityInfo.tel1;
			$telLink.classList.remove('online-phone-1');
			$telLink.classList.add(cityId + '-phone-1');
		}
	}
}